/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable import/order                                 */

/* ***************************************************************** */
import { ScopedAsyncType, ScopedType } from './scoped-type';
import {
  getPlantingProductOverrides,
  putStandardPlantingProducts,
  addNewProduct,
} from '../../lib/api';
import { asyncAction } from './async-action';
import { produce } from 'immer';

const INITIAL_STATE = {
  productOverrides: [],
  loading: false,
};

const AsyncType = ScopedAsyncType('PLANTING_PRODUCTS');
const Type = ScopedType('PLANTING_PRODUCTS');
const LOAD_PRODUCT_OVERRIDES = AsyncType('LOAD_PRODUCT_OVERRIDES');
const SAVE_PRODUCT_OVERRIDES = AsyncType('SAVE_PRODUCT_OVERRIDES');
const OVERRIDE_PRODUCT_NAME = Type('OVERRIDE_PRODUCT_NAME');
const SEND_PRODUCT_REQUEST = AsyncType('SEND_PRODUCT_REQUEST');
const SLICE = 'plantingProducts';

export const selectors = {
  loading: (state) => state[SLICE].loading,
  productOverrides: (state) => state[SLICE].productOverrides,
};

export const actions = {
  loadOverrides,
  updateProductValue,
  saveProductOverrides,
  sendProductRequest,
  ignoreProduct,
  updateProductDisplayName,
};

const reducerHandlers = {
  [LOAD_PRODUCT_OVERRIDES.start]: reduceLoadOverridesStart,
  [LOAD_PRODUCT_OVERRIDES.complete]: reduceLoadOverridesComplete,
  [LOAD_PRODUCT_OVERRIDES.failure]: reduceLoadOverridesFailure,
  [SAVE_PRODUCT_OVERRIDES.start]: reduceSaveOverridesStart,
  [SAVE_PRODUCT_OVERRIDES.complete]: reduceSaveOverridesEnd,
  [SAVE_PRODUCT_OVERRIDES.failure]: reduceSaveOverridesEnd,
  [OVERRIDE_PRODUCT_NAME]: reduceUpdateOverride,
  [SEND_PRODUCT_REQUEST.start]: reduceSendProductRequestStart,
  [SEND_PRODUCT_REQUEST.complete]: reduceSendProductRequestComplete,
  [SEND_PRODUCT_REQUEST.failure]: reduceSendProductRequestFailure,
};

function loadOverrides(growerId, year, aaids) {
  return asyncAction(LOAD_PRODUCT_OVERRIDES, () =>
    getPlantingProductOverrides(growerId, year, aaids),
  );
}

function updateProductValue(crop, productOverride, selectedProduct) {
  const { id: seedId, name: seedName } = selectedProduct;
  const standardized = productOverride.standardized
    ? productOverride.standardized
    : seedName;

  return {
    type: OVERRIDE_PRODUCT_NAME,
    payload: {
      crop,
      updatedOverride: {
        ...productOverride,
        standardized,
        seedName,
        seedId,
      },
    },
  };
}

function ignoreProduct(crop, productOverride, ignore) {
  return {
    type: OVERRIDE_PRODUCT_NAME,
    payload: {
      crop,
      updatedOverride: {
        original: productOverride.original,
        ignore,
      },
    },
  };
}

function updateProductDisplayName(crop, productOverride, standardized) {
  return {
    type: OVERRIDE_PRODUCT_NAME,
    payload: {
      crop,
      updatedOverride: {
        ...productOverride,
        standardized,
      },
    },
  };
}

function saveProductOverrides(growerId, year, aaids) {
  return async (dispatch, getState) => {
    const products = getState()[SLICE].productOverrides.flatMap(
      ({ crop, overrides }) =>
        overrides.map((override) => ({
          crop,
          original: override.original,
          override: override.standardized,
          seedId: override.seedId,
          ignore: override.ignore,
        })),
    );

    dispatch({ type: SAVE_PRODUCT_OVERRIDES.start });
    const payload = {
      aaids,
      products,
    };
    await putStandardPlantingProducts(payload, year, growerId);
    dispatch({ type: SAVE_PRODUCT_OVERRIDES.complete });
  };
}

function sendProductRequest(product) {
  return asyncAction(SEND_PRODUCT_REQUEST, () => addNewProduct(product));
}

function reduceLoadOverridesStart(state) {
  state.productOverrides = [];
  state.loading = true;
}

function reduceLoadOverridesComplete(state, payload) {
  state.productOverrides = payload;
  state.loading = false;
}

function reduceLoadOverridesFailure(state) {
  state.loading = false;
}

function reduceSaveOverridesStart(state) {
  state.productOverrides = [];
  state.loading = true;
}

function reduceSaveOverridesEnd(state) {
  state.loading = false;
}

function reduceUpdateOverride(state, { crop, updatedOverride }) {
  const byCropIndex = state.productOverrides.findIndex(
    (byCrop) => byCrop.crop === crop,
  );
  const overrideIndex = state.productOverrides[byCropIndex].overrides.findIndex(
    (override) => override.original === updatedOverride.original,
  );

  state.productOverrides[byCropIndex].overrides[overrideIndex] =
    updatedOverride;
}

function reduceSendProductRequestStart(state) {
  state.loading = true;
}

function reduceSendProductRequestComplete(state) {
  state.loading = false;
}

function reduceSendProductRequestFailure(state) {
  state.loading = false;
}

export const reducers = {
  [SLICE]: (state = INITIAL_STATE, { type, payload } = {}) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};
